import { Routes } from '@angular/router';
import { AuthGuard } from './services/guards/auth/auth';
import { RolesGuard } from './services/guards/roles/roles';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.LoginPage),
  },
  {
    path: 'auth',
    loadComponent: () => import('./pages/auth/auth').then((m) => m.Auth),
  },
  {
    path: 'backoffice/heaters',
    loadComponent: () =>
      import('./components/auth-layout/auth-layout').then((m) => m.AuthLayout),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        canActivate: [RolesGuard],
        loadComponent: () => import('./pages/home/home').then((m) => m.Home),
        data: { roles: ['admin', 'provider', 'advisor', 'auditor'] },
      },
      {
        path: 'calentadores/auditoria-pendiente',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('./pages/pending-audit/pending-audit').then(
            (m) => m.PendingAudit,
          ),
        data: { roles: ['auditor'] },
      },
      {
        path: 'calentadores/rechazados',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('./pages/heaters-rejected/heaters-rejected').then(
            (m) => m.HeatersRejected,
          ),
        data: { roles: ['admin', 'provider'] },
      },
      {
        path: 'calentadores/gestionar-envio',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('./pages/manage-shipping/manage-shipping').then(
            (m) => m.ManageShipping,
          ),
        data: { roles: ['provider', 'admin'] },
      },
      {
        path: 'administrar/proveedores/gestionar-proveedores',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('./pages/provider/manage/manage').then((m) => m.Manage),
        data: { roles: ['admin'] },
      },

      {
        path: 'administrar/materiales/gestionar-materiales-facturacion',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('./pages/billing-material/manage/manage').then(
            (m) => m.ManageBillingMaterials,
          ),
        data: { roles: ['admin'] },
      },
      {
        path: 'administrar/materiales/gestionar-codigos-inventario',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('./pages/inventory-material-code/manage/manage').then(
            (m) => m.ManageInventoryMaterialCodes,
          ),
        data: { roles: ['admin'] },
      },
      {
        path: 'calentadores/inventario/crear',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('./pages/inventory/create-inventory/create-inventory').then(
            (m) => m.CreateInventory,
          ),
        data: { roles: ['admin', 'provider'] },
      },
      {
        path: 'administrar/planes/gestionar-planes',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('@app/pages/plans/plans').then((m) => m.PlansPage),
        data: { roles: ['admin'] },
      },
      {
        path: 'calentadores/solicitudes-de-retracto',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('./pages/retract-requests/retract-requests').then(
            (m) => m.RetractRequests,
          ),
        data: { roles: ['provider'] },
      },
      {
        path: 'calentadores/solicitudes-de-garantia',
        canActivate: [RolesGuard],
        loadComponent: () =>
          import('./pages/warranty-requests/warranty-requests').then(
            (m) => m.WarrantyRequests,
          ),
        data: { roles: ['provider'] },
      },
      {
        path: '',
        canActivate: [RolesGuard],
        loadComponent: () => import('./pages/home/home').then((m) => m.Home),
        data: { roles: ['admin', 'provider', 'advisor', 'auditor'] },
      },
    ],
  },
  {
    path: 'apps',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/backoffice-apps/backoffice-apps').then(
        (m) => m.BackofficeApps,
      ),
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
